import { render, staticRenderFns } from "./ModalEditLevel.vue?vue&type=template&id=51a9ceeb"
import script from "./ModalEditLevel.vue?vue&type=script&lang=js"
export * from "./ModalEditLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports